import { render, staticRenderFns } from "./job-detail.vue?vue&type=template&id=2e7feae3&scoped=true&"
import script from "./job-detail.vue?vue&type=script&lang=js&"
export * from "./job-detail.vue?vue&type=script&lang=js&"
import style0 from "./job-detail.vue?vue&type=style&index=0&id=2e7feae3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7feae3",
  null
  
)

export default component.exports